import Api from "./Api";
// import ScanApi from "./ScanApi";
import axios from "axios";
import CryptoJS from "crypto-js";
var CryptoJSAesJson = {
  stringify: function (cipherParams) {
    var j = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64) };
    if (cipherParams.iv) j.iv = cipherParams.iv.toString();
    if (cipherParams.salt) j.s = cipherParams.salt.toString();
    return JSON.stringify(j);
  },
  parse: function (jsonStr) {
    var j = JSON.parse(jsonStr);
    var cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(j.ct),
    });
    if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);
    if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);
    return cipherParams;
  },
};

export default {
  updateUserName(params) {
    //todo get userId from store
    const userId = JSON.parse(localStorage.getItem("user")).data.user.id;
    params.id = userId;
    params.first_name = params.form.user.first_name;
    params.last_name = params.form.user.last_name;
    params.update_cloud = params.form.update_cloud == true ? 1 : 0;
    params._method = "put";
    return Api().put("/change-name", params);
  },

  updateUserTimeZone(params) {
    //todo get userId from store
    const userId = JSON.parse(localStorage.getItem("user")).data.user.id;
    params.id = userId;
    params.timezone = params.form.timezone;
    params.update_cloud = 1;
    params._method = "put";
    delete params.form;
    return Api().put("/change-timezone", params);
  },

  updateUserImage(params) {
    //todo get userId from store
    const userId = JSON.parse(localStorage.getItem("user")).data.user.id;
    params.id = userId;
    params.update_cloud = params.form.update_cloud == true ? 1 : 0;
    params._method = "post";
    return Api().post("/change-image", params);
  },

  updateUserEmail(params) {
    //todo get userId from store
    const userId = JSON.parse(localStorage.getItem("user")).data.user.id;
    const key = localStorage.getItem('serverId');
    let encryptedCurrentPassword = CryptoJS.AES.encrypt(
      JSON.stringify(params.form.password),
      key,
      { format: CryptoJSAesJson }
    ).toString();
    params.id = userId;
    params.new_email = params.form.new_email;
    params.password = btoa(encryptedCurrentPassword);
    params.update_cloud = params.form.update_cloud == true ? 1 : 0;
    params._method = "put";
    delete params.form;
    return Api().put("/change-email", params);
  },

  deactivateUserAccount(payload) {
    //todo get userId from store
    // const userId = JSON.parse(localStorage.getItem("user")).data.user.id;
    // const key = localStorage.getItem('serverId');
    // let encryptedCurrentPassword = CryptoJS.AES.encrypt(
    //   JSON.stringify(params.form.password),
    //   key,
    //   { format: CryptoJSAesJson }
    // ).toString();
    // params.id = userId;
    // params.password = btoa(encryptedCurrentPassword);
    // params.update_cloud = params.form.update_cloud == true ? 1 : 0;
    // params._method = "put";
    // delete params.form;
    const key = localStorage.getItem('serverId');
    payload.password = btoa(CryptoJS.AES.encrypt(
      JSON.stringify(payload.password), key,
      { format: CryptoJSAesJson }
    ).toString());
    return Api().put('/deactivate-account', payload);
  },

  updateDefaultEntity(params) {
    return Api().put('/update-default-entity', params);
  },

  updateUserPhone(params) {
    //todo get userId from store
    const userId = JSON.parse(localStorage.getItem("user")).data.user.id;
    const key = localStorage.getItem('serverId');
    let encryptedCurrentPassword = CryptoJS.AES.encrypt(
        JSON.stringify(params.form.password),
        key,
        { format: CryptoJSAesJson }
    ).toString();
    params.id = userId;
    params.phone = params.form.phone;
    params.password = btoa(encryptedCurrentPassword);
    params.update_cloud = params.form.update_cloud == true ? 1 : 0;
    params._method = "put";
    return Api().put("/change-phone", params);
  },

  updateTmpPwdFlag(params) {
    let data = {};
    const userId = JSON.parse(localStorage.getItem("user")).data.user.id;
    data._method = "put";
    data.id = userId;
    data.tmp_pwd = params;
    return Api().put("/update-tmp-pwd-flag", data);
  },

  updateUserPassword(payload) {
    const key = localStorage.getItem('serverId');
    payload.password = btoa(CryptoJS.AES.encrypt(
      JSON.stringify(payload.password), key,
      { format: CryptoJSAesJson }
    ).toString());
    return Api().put("/change-password", payload);
  },

  acceptInvitation(params){
    return Api().post("/accept-invitation", params);
  },

  editCompanyName(params){
    return Api().put("/change-company", params);
  },

  getUserVisits(id){
    return Api().get(`/list-visits/${id}`);
  },
  getUserVisitsByServer(payload){
    return Api().get(`/list-visits-server/${payload.server}/${payload.id}`);
  },

  getUser(email) {
    return Api().get(`/get-user/${email}`);
  },

  resetUserPassword(id, password) {
    let formData = new FormData();
    formData.append('id', id);
    formData.append('password', password);
    return Api().post(`/update-reset-password`, formData);
  },

  getIp() {
    return axios.get("https://api.ipify.org?format=json");
  },

  getSecretKey(url){
    let formData = new FormData();
    formData.append('key', process.env.VUE_APP_PASSPORT_KEY);
    return axios.post(`${url}/api/get_client_secret_for_passport`, formData);
  },

  getCloudToken(url , secret){
    let formData = new FormData();
    formData.append('secret', secret);
    return axios.post(`${url}/api/access_token` , formData);
  },

  validateUserPassword(payload) {
    const key = localStorage.getItem('serverId');
    payload.password = btoa(CryptoJS.AES.encrypt(
      JSON.stringify(payload.password), key,
      { format: CryptoJSAesJson }
    ).toString());
    return Api().post("/validate-password", payload);
  },
};  
